// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"426":"5dc94ed9","827":"6bffe687"}[chunkId] + ".css";
};